module.exports = __webpack_public_path__ + "static/img/correlation-animation.d585a87.gif";